// import React, { useEffect, useRef, useState } from 'react';
// import PropTypes from 'prop-types';
// import { styled, useTheme } from '@mui/material/styles';
// import Box from '@mui/material/Box';
// import Drawer from '@mui/material/Drawer';
// import CssBaseline from '@mui/material/CssBaseline';
// import MuiAppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
// import List from '@mui/material/List';
// import Typography from '@mui/material/Typography';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import PeopleIcon from '@mui/icons-material/People';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import { useMediaQuery } from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import { useDispatch, useSelector } from 'react-redux';
// import { logout } from '../../../redux/slice/auth.slice';
// import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
// import { getsidebar } from '../../../redux/slice/SidebarName.slice';
// import { Image_URL } from '../../../utils/baseURL';
// import MuiDrawer from '@mui/material/Drawer';
// // import { getRoles } from '../../../redux/slice/roles.slice';


// const drawerWidth = 240;
// // const role = localStorage.getItem("role");

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: 'hidden',
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: 'hidden',
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up('sm')]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
//   ({ theme, open }) => ({
//     flexGrow: 1,
//     padding: theme.spacing(3),
//     transition: theme.transitions.create('margin', {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     marginLeft: `-${drawerWidth}px`,
//     ...(open && {
//       transition: theme.transitions.create('margin', {
//         easing: theme.transitions.easing.easeOut,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//       marginLeft: 0,
//     }),
//   }),
// );

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== 'open',
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(['width', 'margin'], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(['width', 'margin'], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const DrawerHeader = styled('div')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
//   justifyContent: 'flex-end',
// }));
// const MenuItem = ({ item, depth = 0, open, onClose }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const theme = useTheme();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const imgUrl = Image_URL;

//   // const handleClick = () => {
//   //   if (item.onClick) {
//   //     item.onClick();
//   //   } else if (item.categoryName && Array.isArray(item.subsidebaradd) && item.subsidebaradd.length === 0) {
//   //     navigate(`/admin/${item.categoryName.toLowerCase().replace(/\s+/g, '-')}`);
//   //   } else {
//   //     setIsOpen(!isOpen);
//   //   }
//   // };

//   const handleClick = () => {
//     if (item.onClick) {
//       item.onClick();
//       onClose(); // Close sidebar on logout
//     } else if (item.categoryName && Array.isArray(item.subsidebaradd) && item.subsidebaradd.length === 0) {
//       navigate(`/admin/${item.categoryName.toLowerCase().replace(/\s+/g, '-')}`);
//       onClose(); // Close sidebar on category selection
//     } else {
//       setIsOpen(!isOpen);
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       const id = localStorage.getItem("id");
//       if (id) {
//         await dispatch(logout({ id, navigate }));
//       }
//       // localStorage.removeItem("id");
//     } catch (error) {
//       console.log(error)
//     }
//   };

//   if (item.subsidebaradd && item.subsidebaradd.length > 0 && item.subsidebaradd.some(subItem => subItem.subcategoryName)) {
//     return (
//       <>
//         <ListItemButton onClick={handleClick} sx={{ pl: 2 * (depth + 1) }}>
//           <ListItemIcon>
//             <img style={{ width: '30px', height: '30px', objectFit: 'cover', objectPosition: 'center center', filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none' }} src={`${imgUrl}/${item.slideBarImage}`} alt="avatar" />
//           </ListItemIcon>
//           <ListItemText primary={item.categoryName} sx={{ color: theme.palette.text.primary }} />
//           {isOpen ? <ExpandLess /> : <ExpandMore />}
//         </ListItemButton>
//         <Collapse in={isOpen} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>
//             {item.subsidebaradd.map((subItem, index) => (
//               <ListItemButton
//                 key={index}
//                 component={NavLink}
//                 to={`/admin/${subItem.subcategoryName.toLowerCase().replace(/\s+/g, '-')}`}
//                 onClick={onClose}
//                 sx={{
//                   // pl: 2,
//                   pl: open ? 2 * (depth + 2) : 3,
//                   pr: 2,
//                   display: 'flex',
//                   justifyContent: 'start',
//                   '&:hover': {
//                     backgroundColor: 'rgba(30, 144, 255, 0.2)',
//                   },
//                 }}
//               >
//                 <ListItemIcon>
//                   <img
//                     style={{
//                       width: '20px',
//                       height: '20px',
//                       objectFit: 'cover',
//                       objectPosition: 'center center',
//                       paddingLeft: 2 * (depth + 2),
//                       filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
//                     }}
//                     src={`${imgUrl}/${subItem.subcategoryimages}`}
//                     alt="avatar"
//                   />
//                 </ListItemIcon>
//                 <Typography variant="body2" sx={{ color: theme.palette.text.primary, fontSize: '14px' }}>
//                   {subItem.subcategoryName}
//                 </Typography>
//               </ListItemButton>
//             ))}
//           </List>
//         </Collapse>
//       </>
//     );
//   }
//   // if (item.subsidebaradd && item.subsidebaradd.length > 0 && item.subsidebaradd.some(subItem => subItem.subcategoryName)) {
//   //   return (
//   //     <>
//   //       <ListItemButton onClick={handleClick} sx={{ pl: 2 * (depth + 1), pr: 2, justifyContent: 'space-between' }}>
//   //         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//   //           <ListItemIcon>
//   //             <img style={{ width: '30px', height: '30px', objectFit: 'cover', objectPosition: 'center center', filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none' }} src={`${imgUrl}/${item.slideBarImage}`} alt="avatar" />
//   //           </ListItemIcon>
//   //           <ListItemText primary={item.categoryName} sx={{ color: theme.palette.text.primary }} />
//   //         </Box>
//   //         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
//   //           {item.subsidebaradd.map((subItem, index) => (
//   //             <ListItemButton
//   //               key={index}
//   //               component={NavLink}
//   //               to={`/admin/${subItem.subcategoryName.toLowerCase().replace(/\s+/g, '-')}`}
//   //               sx={{
//   //                 pl: 2 * (depth + 2),
//   //                 pr: 2,
//   //                 display: 'flex',
//   //                 justifyContent: 'center',
//   //                 '&:hover': {
//   //                   backgroundColor: 'rgba(30, 144, 255, 0.1)',
//   //                 },
//   //               }}
//   //             >
//   //               <Typography variant="body2" sx={{ color: theme.palette.text.primary, fontSize: '14px' }}>
//   //                 {subItem.subcategoryName}
//   //               </Typography>
//   //             </ListItemButton>
//   //           ))}
//   //         </Box>
//   //         {isOpen ? <ExpandLess /> : <ExpandMore />}
//   //       </ListItemButton>
//   //     </>
//   //   );
//   // }
//   else {
//     return (
//       <ListItemButton
//         component={item.categoryName === "Log Out" ? "button" : NavLink}
//         to={item.categoryName === "Log Out" ? undefined : (item.to || item.categoryName)}
//         onClick={item.categoryName === "Log Out" ? handleLogout : handleClick}
//         sx={{
//           minHeight: 48,
//           justifyContent: open ? 'initial' : 'center',
//           px: 2.5,
//           width: '100%',
//           '&:hover': {
//             backgroundColor: 'rgba(30, 144, 255, 0.2)',
//             width: '100%',
//           },
//         }}
//       >
//         <ListItemIcon
//           sx={{
//             minWidth: 0,
//             mr: open ? 3 : 'auto',
//             justifyContent: 'center',
//           }}
//         >
//           {item.categoryName === "Log Out" ? (
//             <PowerSettingsNewIcon />
//           ) : (
//             <img
//               style={{
//                 width: '30px',
//                 height: '30px',
//                 objectFit: 'cover',
//                 objectPosition: 'center center',
//                 filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
//               }}
//               src={`${imgUrl}/${item.slideBarImage}`}
//               alt="avatar"
//             />
//           )}
//         </ListItemIcon>
//         <ListItemText
//           primary={item.categoryName}
//           sx={{
//             opacity: open ? 1 : 0,
//             color: theme.palette.text.primary
//           }}
//         />
//       </ListItemButton>
//     );
//   }

// };

// const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
//   ({ theme, open }) => ({
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: 'nowrap',
//     boxSizing: 'border-box',
//     ...(open && {
//       ...openedMixin(theme),
//       '& .MuiDrawer-paper': openedMixin(theme),
//     }),
//     ...(!open && {
//       ...closedMixin(theme),
//       '& .MuiDrawer-paper': closedMixin(theme),
//     }),
//   }),
// );


// function ResponsiveDrawer(props) {

//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();


//   const [open, setOpen] = React.useState(false);
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

//   const handleLogout = async () => {
//     try {
//       const id = localStorage.getItem("id");
//       if (id) {
//         await dispatch(logout({ id, navigate }));
//       }
//       localStorage.removeItem("id");
//     } catch (error) {
//       console.log(error)
//     }
//   }
//   // const pathSegments = location.pathname.split('/').filter(Boolean);
//   // const pageName = pathSegments.length > 1 ? pathSegments[pathSegments.length - 1].replace(/-/g, ' ') : '';

//   const SideBar = useSelector((state) => state.sidebar.sidebar);
//   // console.log("SideBar88888", SideBar);

//   const hasFetchedData = useRef(false);

//   useEffect(() => {
//     dispatch(getsidebar());
//   }, []);

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <CssBaseline />
//       <AppBar position="fixed" open={open}>
//         {/* <Toolbar>
//           <Typography variant="h6" noWrap component="div">
//             {pageName.charAt(0).toUpperCase() + pageName.slice(1)}
//           </Typography>
//         </Toolbar> */}
//       </AppBar>
//       <StyledDrawer variant="permanent" open={open}>
//         <DrawerHeader
//           style={{
//             display: 'flex',
//             alignItems: 'center', // Ensures all children are vertically centered
//             justifyContent: 'space-between',
//             padding: '0 16px',
//           }}
//         >
//           {open && (
//             <div
//               style={{
//                 flex: 1,
//                 textAlign: 'center',
//                 marginBottom: '1rem',
//                 marginTop: '1rem',
//               }}
//             >
//               <img
//                 alt="logo"
//                 width="100px"
//                 height="80px"
//                 src={`${theme.palette.mode === 'dark'
//                   ? '../../assets/images/logo/dark-logo.png'
//                   : '../../assets/images/logo/logo.svg'
//                   }`}
//                 style={{ cursor: 'pointer', paddingTop: '20px' }}
//               />
//             </div>
//           )}
//           <IconButton onClick={() => setOpen(!open)} style={{ marginLeft: 'auto' }}>
//             {open ? <ChevronLeftIcon /> : <MenuIcon />}
//           </IconButton>
//         </DrawerHeader>

//         <List>
//           {SideBar.map((item) => (
//             item.categoryName !== "Log Out" ? (
//               <MenuItem
//                 key={item.categoryName}
//                 item={{ ...item, to: `/admin/${item.categoryName.toLowerCase().replace(/\s+/g, '-')}` }}
//                 open={open}
//                 onClose={() => setOpen(false)}
//               />
//             ) : null
//           ))}
//           {SideBar.find(item => item.categoryName === "Log Out") && (
//             <MenuItem
//               key="Log Out"
//               item={{ categoryName: "Log Out", onClick: handleLogout }}
//               open={open}
//               onClose={() => setOpen(false)}
//             />
//           )}
//         </List>
//       </StyledDrawer>
//     </Box>
//   );
// }

// ResponsiveDrawer.propTypes = {
//   window: PropTypes.func,
// };

// export default ResponsiveDrawer;


import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Toolbar, useMediaQuery } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../redux/slice/auth.slice';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { getsidebar } from '../../../redux/slice/SidebarName.slice';
import { Image_URL } from '../../../utils/baseURL';
import MuiDrawer from '@mui/material/Drawer';

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));
const MenuItem = ({ item, depth = 0, open, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const imgUrl = Image_URL;

  const handleClick = () => {
    if (item.onClick) {
      item.onClick();
      onClose(); // Close sidebar on logout
    } else if (item.categoryName && Array.isArray(item.subsidebaradd) && item.subsidebaradd.length === 0) {
      navigate(`/admin/${item.categoryName.toLowerCase().replace(/\s+/g, '-')}`);
      onClose(); // Close sidebar on category selection
    } else {
      setIsOpen(!isOpen);
    }
  };

  const handleLogout = async () => {
    try {
      const id = localStorage.getItem("id");
      if (id) {
        await dispatch(logout({ id, navigate }));
      }
    } catch (error) {
      console.log(error)
    }
  };

  if (item.subsidebaradd && item.subsidebaradd.length > 0 && item.subsidebaradd.some(subItem => subItem.subcategoryName)) {
    return (
      <>
        <ListItemButton onClick={handleClick} sx={{ pl: 2 * (depth + 1) }}>
          <ListItemIcon>
            <img style={{ width: '30px', height: '30px', objectFit: 'cover', objectPosition: 'center center', filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none' }} src={`${imgUrl}/${item.slideBarImage}`} alt="avatar" />
          </ListItemIcon>
          <ListItemText primary={item.categoryName} sx={{ color: theme.palette.text.primary }} />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.subsidebaradd.map((subItem, index) => (
              <ListItemButton
                key={index}
                component={NavLink}
                to={`/admin/${subItem.subcategoryName.toLowerCase().replace(/\s+/g, '-')}`}
                onClick={onClose}
                sx={{
                  // pl: 2,
                  pl: open ? 2 * (depth + 2) : 3,
                  pr: 2,
                  display: 'flex',
                  justifyContent: 'start',
                  '&:hover': {
                    backgroundColor: 'rgba(30, 144, 255, 0.2)',
                  },
                }}
              >
                <ListItemIcon>
                  <img
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'cover',
                      objectPosition: 'center center',
                      paddingLeft: 2 * (depth + 2),
                      filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
                    }}
                    src={`${imgUrl}/${subItem.subcategoryimages}`}
                    alt="avatar"
                  />
                </ListItemIcon>
                <Typography variant="body2" sx={{ color: theme.palette.text.primary, fontSize: '14px' }}>
                  {subItem.subcategoryName}
                </Typography>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </>
    );
  }
  else {
    return (
      <ListItemButton
        component={item.categoryName === "Log Out" ? "button" : NavLink}
        to={item.categoryName === "Log Out" ? undefined : (item.to || item.categoryName)}
        onClick={item.categoryName === "Log Out" ? handleLogout : handleClick}
        sx={{
          minHeight: 48,
          justifyContent: open ? 'initial' : 'center',
          px: 2.5,
          width: '100%',
          '&:hover': {
            backgroundColor: 'rgba(30, 144, 255, 0.2)',
            width: '100%',
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : 'auto',
            justifyContent: 'center',
          }}
        >
          {item.categoryName === "Log Out" ? (
            <PowerSettingsNewIcon />
          ) : (
            <img
              style={{
                width: '30px',
                height: '30px',
                objectFit: 'cover',
                objectPosition: 'center center',
                filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
              }}
              src={`${imgUrl}/${item.slideBarImage}`}
              alt="avatar"
            />
          )}
        </ListItemIcon>
        <ListItemText
          primary={item.categoryName}
          sx={{
            opacity: open ? 1 : 0,
            color: theme.palette.text.primary
          }}
        />
      </ListItemButton>
    );
  }
};

const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

function ResponsiveDrawer(props) {
  const theme = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const isLargeScreen = useMediaQuery('(min-width: 501px)');
  const isSmallScreen = useMediaQuery('(max-width: 500px)');

  const handleLogout = async () => {
    try {
      const id = localStorage.getItem("id");
      if (id) {
        await dispatch(logout({ id, navigate }));
      }
      localStorage.removeItem("id");
    } catch (error) {
      console.log(error)
    }
  }
  const SideBar = useSelector((state) => state.sidebar.sidebar);

  useEffect(() => {
    dispatch(getsidebar());
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      {
        isSmallScreen && (
          <AppBar position="fixed" open={open}>
            <Toolbar sx={{ backgroundColor: theme.palette.mode == "light" ? "#fff" : "#141b2d", justifyContent: "flex-end" }}>
              <IconButton onClick={() => setOpen(!open)} style={{ marginRight: 'auto', position: 'absolute', left: 16, top: 16, padding: 0 }}>
                {!open ? <MenuIcon style={{ fontSize: '25px', boxShadow: '1px 1px 3px' }} /> : ''}
              </IconButton>
              <Box>
                <img
                  alt="logo"
                  width="40px"
                  height="40px"
                  src={`${theme.palette.mode === 'dark'
                    ? '../../assets/images/icons/pdfimage4.png'
                    : '../../assets/images/icons/pdfimage4.png'
                    }`}
                  style={{ cursor: 'pointer', marginLeft: "30px" }}
                />
              </Box>
            </Toolbar>
          </AppBar>
        )
      }
      {
        isLargeScreen || open ? (
          <StyledDrawer className={`${theme.palette.mode == "dark" ? "j_header_color" : ""}`} variant="permanent" open={open}>
            <DrawerHeader>
              {open && (
                <div style={{ flex: 1, textAlign: 'center', marginBottom: '1rem', marginTop: '1rem' }}>
                  <img
                    alt="logo"
                    width="100px"
                    height="80px"
                    src={`${theme.palette.mode === 'dark'
                      ? '../../assets/images/logo/dark-logo.png'
                      : '../../assets/images/logo/logo.svg'
                      }`}
                    style={{ cursor: 'pointer', paddingTop: '20px' }}
                  />
                </div>
              )}
              <IconButton onClick={() => setOpen(!open)} style={{ marginLeft: 'auto' }}>
                {open ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton>
            </DrawerHeader>

            <List>
              {SideBar.map((item) => (
                item.categoryName !== "Log Out" ? (
                  <MenuItem
                    key={item.categoryName}
                    item={{ ...item, to: `/admin/${item.categoryName.toLowerCase().replace(/\s+/g, '-')}` }}
                    open={open}
                    onClose={() => setOpen(false)}
                  />
                ) : null
              ))}
              {SideBar.find(item => item.categoryName === "Log Out") && (
                <MenuItem
                  key="Log Out"
                  item={{ categoryName: "Log Out", onClick: handleLogout }}
                  open={open}
                  onClose={() => setOpen(false)}
                />
              )}
            </List>
          </StyledDrawer>
        ) : null
      }
    </Box >
  );
}

ResponsiveDrawer.propTypes = {
  window: PropTypes.func,
};

export default ResponsiveDrawer;